
  export default function symbol(state = {}, action: any){
    console.log("prices reducer action:", action);
    console.log("prices reducer state:", state);
    switch (action.type) {
      case 'RECEIVE_PRICES':
        return {
          ...state,
          prices: action.prices,
          loading: action.loading
        };
      case 'RECEIVE_LAST_PRICE':
        return {
          ...state,
          symbol: action.symbol,
          loading: action.loading
        };     
      default:
        return state;
    }
  }